import { CircularProgress, Stack } from '@mui/material';

const LoadingScreen = () => (
    <Stack justifyContent='center' alignItems='center' width='100vw' height='100vh'>
        <CircularProgress />
    </Stack>
);

export default LoadingScreen;
